import { ChildrenItem } from "dependencies/base"
import { Map3D } from "./model"
import { differentOpt } from "./difference_options"
import { home_differentOpt } from "./home_difference_options"
import icon from "assets/images/leftMenu/chart/cx_map3D.png"
export let map3d_children = []
export let home_map3d_children = []
let homeIcon = "icon-portal-3dmap"
for (let i = 0; i < differentOpt.length; i++) {
  map3d_children.push(new ChildrenItem("3D地图样式" + i, icon, "cxMap3D", new Map3D(differentOpt[i])))
}
for (let i = 0; i < home_differentOpt.length; i++) {
  home_map3d_children.push(new ChildrenItem("3D地图样式" + i, homeIcon, "cxMap3D", new Map3D(home_differentOpt[i])))
}